import React from 'react';
import { IconProps } from '@battlefly/components/Icons';

const MarkCybernetics: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="150"
      height="128"
      viewBox="0 0 150 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M116.597 98.922L128.494 92.4951V88.922L113.416 78.2354C115.063 73.711 115.962 68.8258 115.962 63.7313C115.962 40.3252 96.9886 21.3514 73.5825 21.3514C73.1381 21.3514 72.6953 21.3592 72.254 21.3725L73.5825 19.9862L72.857 17.0199L3.61664 0.213394L0.403564 2.80869L32.8154 28.639L20.9191 35.0659V38.639L34.2002 48.0518C32.2672 52.9018 31.2034 58.1932 31.2034 63.7329C31.2034 87.1389 50.1773 106.113 73.5833 106.113C74.8665 106.113 76.1364 106.056 77.3915 105.944L75.8295 107.574L76.5551 110.54L145.796 127.348L149.009 124.753L116.597 98.922Z"
        fill="url(#paint0_linear_1_1127)"
      />
      <path
        d="M65.8373 52.8237L62.5945 56.0657V71.161L65.8935 74.46H80.8654L84.1918 71.1329V56.1782L80.8069 52.7925L65.8373 52.8237Z"
        fill="url(#paint1_linear_1_1127)"
      />
      <path
        d="M96.4591 59.927C94.7268 59.927 93.2686 61.1251 92.8695 62.7355H86.4442V58.511C89.3308 58.3705 90.4406 56.218 90.6241 55.0613L90.6327 55.0082V50.1378C92.1901 49.8223 93.3655 48.443 93.3655 46.7943C93.3655 44.9137 91.8355 43.3829 89.954 43.3829C88.0734 43.3829 86.5426 44.9129 86.5426 46.7943C86.5426 48.443 87.7188 49.8223 89.2753 50.1378V54.8887C89.2425 55.0324 89.1074 55.5424 88.7294 56.0345C88.2069 56.7147 87.4384 57.0888 86.4434 57.1505V54.8098L82.1666 50.533L64.4541 50.5705L60.3421 54.6825V57.1513C59.3471 57.0888 58.5786 56.7155 58.0561 56.0352C57.6781 55.5424 57.543 55.0332 57.5102 54.8895V50.1386C59.0675 49.8231 60.2429 48.4438 60.2429 46.7951C60.2429 44.9144 58.7129 43.3837 56.8315 43.3837C54.9508 43.3837 53.42 44.9137 53.42 46.7951C53.42 48.4438 54.5962 49.8231 56.1528 50.1386V55.009L56.1613 55.0621C56.3449 56.218 57.4547 58.3705 60.3413 58.5118V62.7363H53.9159C53.5161 61.1259 52.0587 59.9278 50.3264 59.9278C48.2872 59.9278 46.6276 61.5874 46.6276 63.6266C46.6276 65.6659 48.2872 67.3255 50.3264 67.3255C52.0587 67.3255 53.5169 66.1274 53.9159 64.517H60.3413V68.7415C57.4547 68.8821 56.3449 71.0345 56.1613 72.1912L56.1528 72.2443V77.1147C54.5954 77.4302 53.42 78.8095 53.42 80.4582C53.42 82.3388 54.95 83.8696 56.8315 83.8696C58.7121 83.8696 60.2429 82.3396 60.2429 80.4582C60.2429 78.8095 59.0667 77.4302 57.5102 77.1147V72.3638C57.543 72.2201 57.6781 71.7101 58.0561 71.218C58.5786 70.5378 59.3471 70.1637 60.3421 70.102V72.5426L64.5189 76.7195H82.2353L86.4442 72.5106V70.1028C87.4392 70.1652 88.2077 70.5386 88.7302 71.2188C89.1082 71.7116 89.2433 72.2209 89.2761 72.3646V77.1154C87.7188 77.431 86.5434 78.8102 86.5434 80.4589C86.5434 82.3396 88.0734 83.8704 89.9548 83.8704C91.8355 83.8704 93.3663 82.3404 93.3663 80.4589C93.3663 78.8102 92.1901 77.431 90.6335 77.1154V72.2451L90.6249 72.192C90.4414 71.0361 89.3316 68.8836 86.445 68.7423V64.5178H92.8703C93.2702 66.1282 94.7276 67.3263 96.4598 67.3263C98.4991 67.3263 100.159 65.6666 100.159 63.6274C100.158 61.5866 98.4991 59.927 96.4591 59.927ZM87.7305 46.7951C87.7305 45.5689 88.7286 44.5708 89.9548 44.5708C91.181 44.5708 92.1791 45.5689 92.1791 46.7951C92.1791 48.0213 91.181 49.0194 89.9548 49.0194C88.7279 49.0194 87.7305 48.0213 87.7305 46.7951ZM56.8322 49.0194C55.6061 49.0194 54.6079 48.0221 54.6079 46.7951C54.6079 45.5682 55.6061 44.5708 56.8322 44.5708C58.0584 44.5708 59.0565 45.5689 59.0565 46.7951C59.0565 48.0213 58.0584 49.0194 56.8322 49.0194ZM52.6304 64.0492C52.4305 65.1395 51.4745 65.9681 50.3272 65.9681C49.0354 65.9681 47.985 64.9176 47.985 63.6259C47.985 62.3341 49.0354 61.2836 50.3272 61.2836C51.4745 61.2836 52.4305 62.1123 52.6304 63.2026V64.0492ZM59.0565 80.4574C59.0565 81.6836 58.0584 82.6817 56.8322 82.6817C55.6061 82.6817 54.6079 81.6836 54.6079 80.4574C54.6079 79.2312 55.6061 78.2331 56.8322 78.2331C58.0584 78.2331 59.0565 79.2304 59.0565 80.4574ZM85.0876 71.9467L81.6738 75.3605H65.0813L61.6995 71.9788V55.2449L65.018 51.9263L81.6074 51.892L85.0884 55.3729V71.9467H85.0876ZM89.954 78.2331C91.1802 78.2331 92.1784 79.2304 92.1784 80.4574C92.1784 81.6844 91.1802 82.6817 89.954 82.6817C88.7279 82.6817 87.7297 81.6836 87.7297 80.4574C87.7297 79.2312 88.7279 78.2331 89.954 78.2331ZM96.4591 65.9681C95.3118 65.9681 94.3558 65.1395 94.1559 64.0492V63.2033C94.3558 62.113 95.3118 61.2844 96.4591 61.2844C97.7509 61.2844 98.8013 62.3349 98.8013 63.6266C98.8013 64.9176 97.7509 65.9681 96.4591 65.9681Z"
        fill="url(#paint2_linear_1_1127)"
      />
      <path
        d="M68.563 50.0308C70.321 50.0308 71.7518 48.6 71.7518 46.842C71.7518 45.3487 70.7194 44.0921 69.3307 43.7468V37.612H67.7953V43.7468C66.4066 44.0913 65.3741 45.3479 65.3741 46.842C65.3741 48.6 66.8049 50.0308 68.563 50.0308ZM68.1983 44.8567H68.9277C69.8673 45.0293 70.5819 45.8532 70.5819 46.842C70.5819 47.9557 69.6759 48.8609 68.563 48.8609C67.45 48.8609 66.5441 47.9549 66.5441 46.842C66.5441 45.8532 67.2587 45.0285 68.1983 44.8567Z"
        fill="url(#paint3_linear_1_1127)"
      />
      <path
        d="M78.2241 50.0308C79.9821 50.0308 81.4129 48.6 81.4129 46.842C81.4129 45.3487 80.3804 44.0921 78.9918 43.7468V37.612H77.4563V43.7468C76.0677 44.0913 75.0352 45.3479 75.0352 46.842C75.0352 48.6 76.4652 50.0308 78.2241 50.0308ZM77.8593 44.8567H78.5888C79.5284 45.0293 80.243 45.8532 80.243 46.842C80.243 47.9557 79.337 48.8609 78.2241 48.8609C77.1103 48.8609 76.2052 47.9549 76.2052 46.842C76.2044 45.8532 76.919 45.0285 77.8593 44.8567Z"
        fill="url(#paint4_linear_1_1127)"
      />
      <path
        d="M78.2241 77.2217C76.466 77.2217 75.0352 78.6525 75.0352 80.4105C75.0352 81.9038 76.0677 83.1605 77.4563 83.5057V89.6405H78.9918V83.5057C80.3804 83.1612 81.4129 81.9046 81.4129 80.4105C81.4129 78.6517 79.9821 77.2217 78.2241 77.2217ZM78.5888 82.3958H77.8593C76.9198 82.2232 76.2052 81.3993 76.2052 80.4105C76.2052 79.2968 77.1111 78.3916 78.2241 78.3916C79.3378 78.3916 80.243 79.2976 80.243 80.4105C80.243 81.3993 79.5284 82.2232 78.5888 82.3958Z"
        fill="url(#paint5_linear_1_1127)"
      />
      <path
        d="M68.563 77.2217C66.8049 77.2217 65.3741 78.6525 65.3741 80.4105C65.3741 81.9038 66.4066 83.1605 67.7953 83.5057V89.6405H69.3307V83.5057C70.7194 83.1612 71.7518 81.9046 71.7518 80.4105C71.7518 78.6517 70.321 77.2217 68.563 77.2217ZM68.9277 82.3958H68.1983C67.2587 82.2232 66.5441 81.3993 66.5441 80.4105C66.5441 79.2968 67.45 78.3916 68.563 78.3916C69.6759 78.3916 70.5819 79.2976 70.5819 80.4105C70.5819 81.3993 69.8673 82.2232 68.9277 82.3958Z"
        fill="url(#paint6_linear_1_1127)"
      />
      <path
        d="M77.1666 107.698L144.12 124.012L113.718 99.9123L106.796 104.238L105.19 101.317L124.223 89.7772L108.963 77.8004L108.6 78.3018C110.513 73.7134 111.516 68.7462 111.516 63.6251C111.516 53.4423 107.551 43.8687 100.35 36.6686C93.1499 29.4684 83.5763 25.5025 73.3935 25.5025C63.6848 25.5025 54.5298 29.1076 47.457 35.6845L46.6284 34.477L70.5702 19.2755L3.61664 2.96333L34.019 27.0629L40.9403 22.7377L42.5468 25.6587L23.5144 37.1973L38.2622 48.7718C36.3003 53.4095 35.2709 58.4392 35.2709 63.6266C35.2709 73.8094 39.2361 83.383 46.437 90.5832C53.6371 97.7833 63.2107 101.749 73.3935 101.749C83.4217 101.749 92.8586 97.9036 100.02 90.9096L101.108 92.4966L77.1666 107.698ZM92.308 92.6068L89.9814 89.0422C85.2133 92.16 79.5159 93.9751 73.3935 93.9751C67.3329 93.9751 61.6878 92.1975 56.9494 89.1367L54.6384 92.7114C45.0999 86.5399 38.7745 75.808 38.7745 63.6259C38.7745 51.5265 45.0156 40.8587 54.4463 34.6668L56.794 38.2173C61.5644 35.094 67.2665 33.2766 73.3935 33.2766C79.4831 33.2766 85.1516 35.0714 89.9041 38.1587L92.2041 34.577C101.711 40.7548 108.013 51.4679 108.013 63.6259C108.013 75.7401 101.757 86.4188 92.308 92.6068Z"
        fill="url(#paint7_linear_1_1127)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1_1127"
          x1="0.403307"
          y1="63.7805"
          x2="149.01"
          y2="63.7805"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#434343" />
          <stop offset="0.4888" stopColor="#3B3C3B" />
          <stop offset="1" stopColor="#4A494A" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1_1127"
          x1="62.5948"
          y1="63.6262"
          x2="84.1919"
          y2="63.6262"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DFEBF8" />
          <stop offset="0.5" stopColor="#F9D1DA" />
          <stop offset="1" stopColor="#E0E6F4" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1_1127"
          x1="46.6286"
          y1="63.6261"
          x2="100.158"
          y2="63.6261"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DFEBF8" />
          <stop offset="0.5" stopColor="#F9D1DA" />
          <stop offset="1" stopColor="#E0E6F4" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1_1127"
          x1="65.3741"
          y1="43.8216"
          x2="71.7517"
          y2="43.8216"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DFEBF8" />
          <stop offset="0.5" stopColor="#F9D1DA" />
          <stop offset="1" stopColor="#E0E6F4" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1_1127"
          x1="75.035"
          y1="43.8216"
          x2="81.4126"
          y2="43.8216"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DFEBF8" />
          <stop offset="0.5" stopColor="#F9D1DA" />
          <stop offset="1" stopColor="#E0E6F4" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1_1127"
          x1="75.035"
          y1="83.4307"
          x2="81.4126"
          y2="83.4307"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DFEBF8" />
          <stop offset="0.5" stopColor="#F9D1DA" />
          <stop offset="1" stopColor="#E0E6F4" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1_1127"
          x1="65.3741"
          y1="83.4307"
          x2="71.7517"
          y2="83.4307"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DFEBF8" />
          <stop offset="0.5" stopColor="#F9D1DA" />
          <stop offset="1" stopColor="#E0E6F4" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1_1127"
          x1="3.61661"
          y1="63.4873"
          x2="144.121"
          y2="63.4873"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DFEBF8" />
          <stop offset="0.5" stopColor="#F9D1DA" />
          <stop offset="1" stopColor="#E0E6F4" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default MarkCybernetics;
